console.log('js/dialogs_redesign.js -> v0.1.0');

$(function() {
	var MaxFileSize = 10 * 1024 * 1024;

	function textareaUpdate() {
		var $this = $(this);
		if ($(this).is(":visible")) {
			var $container = $(".inner-container.messenger-form");

			var height = Math.min(108, ($this.val().length == 0) ? 28 : this.scrollHeight);

			$this.css("height", height + "px");
			$container.css("height", (height + 14) + "px");
		}
	};

	$("textarea.simple-message-form.mobile[name='message']").keyup(textareaUpdate);

	if(typeof exp_dialogs_cust_resizable_textarea != 'undefined' && exp_dialogs_cust_resizable_textarea){
		$("#simple_message_form_message").on('change keyup paste',
			function () {
				$(".inner-container.messenger-form").css('height','auto');
				$('#message-history-wrapper').css('padding-bottom',$(".inner-container.messenger-form").css('height'));
			}
		);
	}

	$("#message-form-submit").on('click', function(e) {
		e.preventDefault();

		var $errors = $("#message-form-errors");
		$errors.text('').addClass('hide');

		var $this = $(this);

		var textEnabled = $this.val();
		var textDisabled = $this.data("disable-with");

		$this.attr("disabled", 1);
		$this.html(textDisabled);

		function reenable() {
			$this.html(textEnabled);
			$this.removeAttr("disabled");
		}

		function textareaSelect(all) {
			$("textarea.simple-message-form[name='message']").each(function() {
				if (all || $(this).is(":visible")) {
					$(this).removeAttr("disabled");
				} else {
					$(this).attr("disabled", 1);
				}
			});
		}

		function showLocalError(error) {
			var error = $("#message-form-client-errors #" + error).text();
			if (error && error.length)
				$errors.text(error).removeClass('hide');
		}

		var $form = $("#new_simple_message_form");
		const ForbiddenCharactersRegex = /[\\\/:\*\?"<>\|]/; // forbidden characters \ / : * ? " < > |
		$form.ajaxSubmit({
			dataType: "html",

			beforeSerialize: function() {
				textareaSelect();
				var $files = $("#message-form-wrapper input:file");
				if ($files.filter(function () { return this.files && this.files.length && this.files[0].size > MaxFileSize }).length > 0) {
					showLocalError("file_too_large");
					reenable();
					return false;
				}
				else if ($files.filter(function () { return this.files && this.files.length && ForbiddenCharactersRegex.test(this.files[0].name) }).length > 0) {
					showLocalError("file_name_invalid");
					reenable();
					return false;
				}
			},

			success: function(result) {

				$('.js-customer-dialogs-history').html(result);

				$('html, body').animate({
			        scrollTop: $('.js-customer-dialogs-history').offset().top - 20
			    }, 400);

				$('.js-customer-dialogs-history').find('.message-customer:first-child').addClass('message-customer--animate');

				$("#message-form-wrapper .js-attachments-wrp .list").html('');

				$form[0].reset();

				textareaUpdate.apply($("textarea.simple-message-form.mobile[name='message']")[0]);

				if(typeof exp_dialogs_cust_resizable_textarea != 'undefined' && exp_dialogs_cust_resizable_textarea){
					$("textarea#simple_message_form_message").css('height','60px');
					$('#message-history-wrapper').css('padding-bottom','130px');
				}
			},

			error: function(o) {
				var error = o.responseText && o.responseText.trim();
				if (error && error.length) {
					$errors.text(o.responseText.trim()).removeClass('hide');
				} else {
					 showLocalError("failed_contact_server");
				}

				reenable();
			},

			complete: function() {
				textareaSelect(true);
				reenable();
			},
		});

		return false;
	});

	function slotsFree() {
		var frees = [];
		$("#message-form-wrapper input:file").each(function() {
			if (!this.files || (this.files.length == 0))
				frees.push(this);
		});
		return $(frees);
	}

	function readableSize(bytes) {
		var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
		var e = Math.floor(Math.log(bytes) / Math.log(1024));
		return (bytes / Math.pow(1024, e)).toFixed(1) + " " + s[e];
	}

	function decorateSize(bytes) {
		var readable = readableSize(bytes);
		if (bytes <= MaxFileSize)
			return readable;
		return "<span style='color: red;'>" + readable + "</span>";
	}

	$("#message-form-wrapper").on('change', "input.slot", function () {
		var $frees = slotsFree();
		var slot = $frees.length ? $frees.first().attr('id') : 'undefined';

		$('label.attachment').attr('for', slot);
		$('.js-attachments-wrp').trigger('addfile');
	});

	$("#message-form-wrapper").on('addfile', '.js-attachments-wrp', function () {
		var $wrapper = $(this);
		var $list = $wrapper.find('.list').html('');
		$wrapper.find("input:file").each(function () {
			if (this.files && this.files.length > 0) {
				$list.append("<li file-id='" + this.id + "'><span class='file-name'>" + this.files[0].name + " (" + decorateSize(this.files[0].size) + ")</span><span class='close delete'>&times;</span></li>");
			}
		});
	});

	$("#message-form-wrapper").on('click', '.js-attachments-wrp .delete', function () {
		var $item = $(this).closest("li");
		var id = $item.attr("file-id");
		$item.remove();

		$("#" + id).replaceWith('<input class="slot" id="' + id + '" name="file" type="file">');
		$('label.attachment').attr('for', slotsFree().first().attr('id'));
	});

});
